module.exports = __webpack_public_path__ + "img/视频封面3.fba03792.png";